export default method => context => {
  context.state.set(
    'app.snackbars',
    context.state.get('app.snackbars').reduce(method.bind(null, context), [])
  )
}



// WEBPACK FOOTER //
// ./src/modules/App/factories/snackbarListManipulation.js